import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import Screenfull from "@/components/Screenfull";
import SizeSelect from "@/components/SizeSelect";
import LangSelect from "@/components/LangSelect";
import Search from "@/components/HeaderSearch";
import MessageList from "./MessageList";
import Settings from "./settings";
import UserList from "./userList/UserList";
import dragDialog from "@/directive/el-drag-dialog";
import ReconnectingWebSocket from "reconnecting-websocket";
export default {
  directives: {
    dragDialog: dragDialog
  },
  components: {
    Screenfull: Screenfull,
    SizeSelect: SizeSelect,
    LangSelect: LangSelect,
    Search: Search,
    MessageList: MessageList,
    UserList: UserList,
    Settings: Settings
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    showLanguage: function showLanguage(state) {
      return state.settings.showLanguage;
    },
    showSearch: function showSearch(state) {
      return state.settings.showSearch;
    },
    showSettings: function showSettings(state) {
      return state.settings.showSettings;
    }
  })), mapGetters(["device", "userInfo"])),
  data: function data() {
    return {
      define: {
        comUrl: "http://211.141.162.40:8556"
      },
      visible: false,
      isTwinkle: false,
      messageCount: 0,
      userList: [],
      NODE_ENV: ""
    };
  },
  created: function created() {
    this.userInfo.headIcon = this.userInfo.headIcon.includes("userAvatar") ? this.userInfo.headIcon : "/api/File/Image/userAvatar/" + this.userInfo.headIcon;
    this.NODE_ENV = process.env.NODE_ENV;
  },
  destroyed: function destroyed() {
    if (this.socket) {
      // 离开路由之后断开websocket连接
      this.socket.close();
      this.socket = null;
      this.$store.commit("user/SET_SOCKET", this.socket);
    }
  },
  methods: {
    initWebSocket: function initWebSocket() {
      // this.socket = this.$store.getters.socket || null
      // if ('WebSocket' in window) {
      //   if (!this.socket) {
      //     this.socket = new ReconnectingWebSocket(this.define.WebSocketUrl)
      //     this.$store.commit('user/SET_SOCKET', this.socket)
      //   }
      //   // 添加事件监听
      //   const socket = this.socket
      //   socket.onopen = () => {
      //     var onConnection = {
      //       method: 'OnConnection',
      //       token: this.$store.getters.token,
      //       mobileDevice: false
      //     }
      //     socket.send(JSON.stringify(onConnection))
      //   }
      //   socket.onmessage = event => {
      //     const data = JSON.parse(event.data)
      //     if (data.method == 'initMessage') {
      //       this.messageCount = data.unreadMessageCount + data.unreadNoticeCount
      //       this.isTwinkle = !!data.unreadNums.length
      //     }
      //     // 用户在线
      //     if (data.method == 'Online') {
      //     }
      //     // 用户离线
      //     if (data.method == 'Offline') {
      //     }
      //     // 消息推送（消息公告用的）
      //     if (data.method == 'messagePush') {
      //       this.messageCount += data.unreadNoticeCount
      //       if (this.$refs.MessageList.visible) this.$refs.MessageList.init()
      //     }
      //     // 用户过期
      //     if (data.method == 'logout') {
      //       this.$message({
      //         message: data.msg || '登录过期,请重新登录',
      //         type: 'error',
      //         duration: 1000,
      //         onClose: () => {
      //           this.$store.dispatch('user/resetToken').then(() => {
      //             location.reload()
      //           })
      //         }
      //       })
      //     }
      //     // 接收对方发送的消息
      //     if (data.method == 'receiveMessage') {
      //       // 判断是否打开窗口
      //       if (
      //         this.$refs.UserList &&
      //         this.$refs.UserList.$refs.WeforsysIm &&
      //         this.$refs.UserList.$refs.WeforsysIm.visible
      //       ) {
      //         if (
      //           this.$refs.UserList.$refs.WeforsysIm.info.id === data.formUserId
      //         ) {
      //           const messIitem = {
      //             userId: data.formUserId,
      //             messageType: data.messageType,
      //             message: data.formMessage,
      //             dateTime: this.weforsys.toDate(data.dateTime)
      //           }
      //           this.$refs.UserList.$refs.WeforsysIm.addItem(messIitem)
      //           // 更新已读
      //           const updateReadMessage = {
      //             method: 'UpdateReadMessage',
      //             formUserId: data.formUserId,
      //             token: this.$store.getters.token
      //           }
      //           socket.send(JSON.stringify(updateReadMessage))
      //           this.$refs.UserList.updateReply(data)
      //         } else {
      //           this.$refs.UserList.updateReply(data, 1)
      //           this.isTwinkle = true
      //         }
      //       } else {
      //         this.$refs.UserList.updateReply(data, 1)
      //         this.isTwinkle = true
      //       }
      //     }
      //     // 显示自己发送的消息
      //     if (data.method == 'sendMessage') {
      //       if (
      //         this.$refs.UserList.$refs.WeforsysIm.info.id !== data.toUserId
      //       ) {
      //         return
      //       }
      //       // 添加到客户端
      //       const messIitem = {
      //         userId: data.UserId,
      //         messageType: data.messageType,
      //         message: data.toMessage,
      //         dateTime: this.weforsys.toDate(data.dateTime)
      //       }
      //       this.$refs.UserList.updateLatestMessage(data)
      //       this.$refs.UserList.$refs.WeforsysIm.addItem(messIitem)
      //     }
      //     // 消息列表
      //     if (data.method == 'messageList') {
      //       this.$refs.UserList.$refs.WeforsysIm.getList(data)
      //     }
      //   }
      // }
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    handleLogout: function handleLogout() {
      var _this = this;
      this.$confirm("您确定要退出应用程序吗?", "提示", {
        type: "warning"
      }).then(function () {
        _this.logout();
      }).catch(function () {});
    },
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$store.dispatch("user/logout");
            case 1:
              // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
              this.$router.push("/login");
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    lock: function lock() {
      var _this2 = this;
      this.$store.dispatch("user/setLock");
      this.$nextTick(function () {
        _this2.$router.push("/lockScreen");
      });
    },
    read: function read(isAll) {
      if (isAll) {
        this.messageCount = 0;
      } else {
        this.messageCount -= 1;
        this.messageCount = this.messageCount >= 0 ? this.messageCount : 0;
      }
    },
    openUserList: function openUserList() {
      this.$refs.UserList.init();
    },
    changeTwinkle: function changeTwinkle(boo) {
      this.isTwinkle = boo;
    }
  }
};